///////////////////////////////////////////////////////////////////////////////
// Brand slug + display name for a carrier, for matching /topup/:country/:carrier
// and building those links. A browser-safe copy of brandSlug()/brandName() in
// lib/carrierSlugs.js, which can't be imported here: it pulls in
// lib/carrierLogos.js, which reads the logo manifest off disk (fs) at load.
// Keep the two in step; test/unit/carrierSlugs.test.js pins them together.
///////////////////////////////////////////////////////////////////////////////
const SLUG_TAIL = [
  'united kingdom', 'united states', 'new zealand', 'south korea', 'south africa', 'czech republic',
  'usa', 'us', 'uk', 'gb', 'england', 'scotland', 'wales', 'mexico', 'canada', 'philippines',
  'australia', 'germany', 'france', 'spain', 'italy', 'belgium', 'switzerland', 'netherlands',
  'india', 'indonesia', 'thailand', 'vietnam', 'japan', 'singapore', 'malaysia', 'myanmar',
  'brazil', 'argentina', 'chile', 'colombia', 'peru', 'nigeria', 'kenya', 'pin', 'pins',
];

function stripTail(words) {
  const w = words.slice();
  for (;;) {
    const hit = SLUG_TAIL.find((p) => {
      const parts = p.split(' ');
      return w.length > parts.length && parts.every((x, i) => w[w.length - parts.length + i] === x);
    });
    if (!hit) return w;
    w.length -= hit.split(' ').length;
  }
}

export function slugifyCarrierName(name) {
  const w = String(name || '').toLowerCase()
    .replace(/\(.*?\)/g, ' ')
    .replace(/\b(formerly|operator service fee applied|service fee applied)\b/g, ' ')
    .replace(/[^a-z0-9&]+/g, ' ').trim().split(' ').filter(Boolean);
  const brand = stripTail(w).join(' ');
  const fixed = brand === 'giff gaff' ? 'giffgaff' : brand;
  return fixed.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

// "EE PIN England" -> "EE". Keeps the supplier's capitalisation.
export function carrierBrandName(name) {
  const clean = String(name || '').replace(/\(.*?\)/g, ' ').replace(/\s+/g, ' ').trim();
  const words = clean.split(' ').filter(Boolean);
  const kept = stripTail(words.map((w) => w.toLowerCase().replace(/[^a-z0-9&]/g, '')));
  return words.slice(0, kept.length).join(' ') || clean;
}
